import { FC } from "react"
import { bossLogo, bossHeroLogo } from "assets/images"
import {
  refferalIcon,
  shovelIcon,
  upgradeIconBag,
  walletIcon,
  HeroIcon,
  bossArenaIcon
} from "assets/icons"

interface IconProps {
  iconName: string
}

const icons: Record<string, JSX.Element> = {
  home: <img src={shovelIcon} alt="home" />,
  hero: <img src={HeroIcon} alt="hero" />,
  darkHero: <img src={bossHeroLogo} alt="dark hero" />,
  boss: <img src={bossLogo} alt="boss" />,
  arena: <img src={bossArenaIcon} alt="arena" />,
  inventory: <img src={upgradeIconBag} alt="inventory" />,
  items: <img src={upgradeIconBag} alt="upgrades" />,
  referrals: <img src={refferalIcon} alt="refferals" />,
  wallet: <img src={walletIcon} alt="wallet" />
}

export const FooterIcon: FC<IconProps> = ({ iconName }) => {
  return icons[iconName] || null
}
